"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.useRandomId = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const RandomIdContext = /*#__PURE__*/React.createContext(() => {
  throw new Error("Orbit RandomIdProvider: Internal error - RandomIdContext used outside of Provider.");
});
const RandomIdProvider = ({
  children
}) => {
  const generateId = React.useId;
  return /*#__PURE__*/React.createElement(RandomIdContext.Provider, {
    value: generateId
  }, children);
};
const useRandomId = () => React.useContext(RandomIdContext);
exports.useRandomId = useRandomId;
var _default = exports.default = RandomIdProvider;